<template>
	<div class="goods-list" v-loading="loading">

		<div class="block-container">
			<!-- <span @click="load()">刷新</span> -->
			
			<!-- <div class="box type">
				<div class="name">类别:</div>
				<div class="value">
					<el-tag
					:effect="filters.type === 0?'dark':'plain'"
					@click="filters.type=0" 
					@close="filters.type=1">
					设备求购
					</el-tag>
					<el-tag
					:effect="filters.type === 1?'dark':'plain'"
					@click="filters.type=1" 
					@close="filters.type=0">
					设备求租
					</el-tag>
				</div>
			</div> -->
			<div class="box city">
				<div class="name">地区:</div>
				<div class="value">
					<!-- <span @click="load()">刷新</span> -->
					<el-tag 
					v-for="(item,i) in area.province" :key="item.id" 
					:closable="filters.province_id == item.id" 
					:effect="filters.province_id == item.id?'dark':'plain'"
					v-if="filters.province_id==0 || filters.province_id == item.id"
					@click="filters.province_id=item.id" @close="filters.province_id=0">
					{{item.shortname}}
					</el-tag>
					<template v-if="filters.province_id != 0">
						<el-tag 
						v-for="(item,i) in area.province.find((v)=>{if(v.id == filters.province_id){return v}}).child" 
						:key="item.id" 
						:closable="filters.city_id == item.id" 
						:effect="filters.city_id == item.id?'dark':'plain'"
						@click="filters.city_id=item.id" @close="filters.city_id=0">
						{{item.shortname}}
						</el-tag>
					</template>
				</div>
			</div>
			<div class="box price">
				<div class="name">月薪:</div>
				<div class="value">
					<!-- <span @click="load()">刷新</span> -->
					<!-- :closable="filters.min_price === item.min_price" -->
					<el-tag
					v-for="(item,i) in priceList" :key="item.id" 
					:effect="filters.min_price === item.min_price?'dark':'plain'"
					@click="filters.min_price=item.min_price;filters.max_price=item.max_price" 
					@close="filters.min_price='';filters.max_price=''">
					{{item.name}}
					</el-tag>
				</div>
			</div>
			<div class="box price">
				<div class="name">工作经验:</div>
				<div class="value">
					<!-- <span @click="load()">刷新</span> -->
					<el-tag
					v-for="(item,i) in workingList" :key="item.id" 
					:effect="filters.working == i?'dark':'plain'"
					@click="filters.working = i" 
					@close="filters.working = 0">
					{{item}}
					</el-tag>
				</div>
			</div>
			<div class="box price">
				<div class="name">学历:</div>
				<div class="value">
					<!-- <span @click="load()">刷新</span> -->
					<!-- :closable="filters.min_price === item.min_price" -->
					<el-tag
					v-for="(item,i) in educationList" :key="item.id" 
					:effect="filters.education == i?'dark':'plain'"
					@click="filters.education = i" 
					@close="filters.education = 0">
					{{item}}
					</el-tag>
				</div>
			</div>
			
		</div>

		<!-- 搜索关键字 -->
		<div class="search_bread" v-if="keyword">
			<span>搜索结果：</span>
			<span class="keyword">'{{ keyword}}'</span>
		</div>
		
		<div class="list-wrap">

			<div class="list">
				<!-- 排序筛选区 -->
				
				<div class="cargo-list" v-if="cargoList.length">
					<div class="job-list">
						<div class="item" v-for="(item,i) in  cargoList" :key="item.id"  @click="$router.pushToTab({ path: '/job-detail-' + item.id })">
							<div class="info">
								<h2>{{item.title}}</h2>
								<div >
									<!-- {{typeof item.salary}} -->
									<span class="salary" v-if="item.salary >0 && typeof item.salary == 'number'">{{Math.round(item.salary/1000)}}K</span>
									<span class="salary" v-else>面议</span>
									<span>{{item.area.name}}</span>
									<span>{{workingList[item.working]}}</span>
									<span>{{educationList[item.education]}}</span>
									<span>{{item.create_time.split(' ')[0]}}</span>
								</div>
							</div>
							<div class="con">
								<h3>{{item.site.site_name}}</h3>
							</div>
						</div>
					</div>
					
					<div class="pager">
						<el-pagination background :pager-count="5" :total="total" prev-text="上一页" next-text="下一页" :current-page.sync="currentPage"
						 :page-size.sync="pageSize" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange"
						 hide-on-single-page></el-pagination>
					</div>
				</div>
				<div class="empty" v-else>
					<div class="ns-text-align">没有找到您想要的设备。换个条件试试吧</div>
				</div>
			</div>
			<div class="ad">
				<el-image v-if="adList[0]" :src="$img(adList[0].adv_image)" fit="cover" @click="$router.pushToTab(adList[0].adv_url.url)" />
				<el-image v-else src="" fit="cover"  />
				<el-image v-if="adList[1]" :src="$img(adList[1].adv_image)" fit="cover" @click="$router.pushToTab(adList[1].adv_url.url)" />
				<el-image v-else src="" fit="cover"  />
				<el-image v-if="adList[2]" :src="$img(adList[2].adv_image)" fit="cover" @click="$router.pushToTab(adList[2].adv_url.url)" />
				<el-image v-else src="" fit="cover"  />
			</div>
		</div>
		<div class="other">
			<used-recommend :num="4"></used-recommend>
		</div>
	</div>
</template>

<script>
	import BreadCrumbs from "@/components/BreadCrumbs";
	// import GoodsRecommend from "@/components/GoodsRecommend";
	import index from "./public/index";
	import UsedRecommend from "../used/components/recommend"

	export default {
		name: "index",
		components: {
			BreadCrumbs,
			UsedRecommend
		},
		data: () => {
			return {};
		},
		mixins: [index],
		created() {},
		methods: {}
	};
</script>

<style lang="scss" scoped>
	.goods-list {
		background: #fff;
		padding-top: 10px;
	}

	.search_bread {
		display: inline-block;
		font-size: 14px;
		margin: 0px auto;
		width: 100%;
		padding: 10px;
	}

	.selected_border {
		border: 1px solid $base-color;
	}

	.attr_filter {
		.el-tag {
			margin-right: 5px;
			margin-bottom: 10px;
			border-radius: 0;

			.title {
				color: $base-color;
				font-size: 15px;
			}
		}
	}

	.category {
		margin: 0 auto 10px auto;
		border: 1px solid #eeeeee;

		.brand {
			border-bottom: 1px solid #eeeeee;
			display: flex;
			flex-direction: row;

			&:last-child {
				border-bottom: none;
			}

			.table_head {
				width: 140px;
				min-width: 140px;
				border-right: 1px solid #eeeeee;
				padding-left: 10px;
				padding-top: 10px;
				background-color: #f2f6fc;
			}

			.table_body {
				flex-grow: 1;

				.initial {
					margin: 5px auto 10px 10px;

					span {
						border: 0;
						margin: 0;
						padding: 5px 10px;
						border: 0;
						border-radius: 0;

						&:hover {
							background-color: $base-color;
							color: #ffffff;
						}
					}
				}

				.content {
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					padding: 10px;
					width: 900px;

					.brand-item {
						margin-right: 10px;
						margin-top: 10px;
					}

					.el-card {
						width: 125px;
						height: 45px;

						&:hover {
							border: 1px solid $base-color;
							cursor: pointer;
						}
					}

					span {
						margin: auto 25px;
					}
				}
			}

			.table_op {
				margin-top: 5px;
				margin-right: 5px;
			}

			.el-image {
				width: 100%;
				height: 100%;
			}
		}
	}

	.list-wrap {
		overflow: hidden;
		display: flex;

		.list {
			// float: left;
			flex: 1;
			margin-top: 10px;
			margin-right: 15px;
			.item{
				display: flex;
				flex-wrap: wrap;
				padding: 15px;
				margin-bottom: 15px;
				border:1px solid #eee;
				.info{
					flex:1;
					display: block;
					h2{
						color: $base-color;
						font-size: 16px;
						line-height: 30px;
					}
					div {
						margin: 5px 0 0 0;
						display: block;
						height: 25px;
						.salary{
							color: $base-color;
							font-size: 16px;
							line-height: 20px;
							// width: 60px;
						}
						span{
							// margin:0  10px;
							line-height: 16px;
							height: 16px;
							// padding-right: 10px;
							display: flex;
							float: left;
							width: auto;
							text-align: center;
							border-right: 1px solid #000;
							margin:0 10px 0 0;
							padding-right: 10px;
						}
						// span::after{
						// 	content:'|';
						// 	font-size: 13px;
						// 	display: block;
						// 	width: 1px;
						// 	// height: 16px;
						// 	// width: 1px;
						// 	margin: 0 10px;
						// 	color: #303133;
						// 	// height: 24px;
						// 	// line-height: 28px;
						// 	overflow: hidden;
						// 	border-right: 1px solid #000;
						// }
						span:last-child{
							// display: none;
							border:0
						}
					}
				}
				.con{
					width: 300px;
					display: block;
					h3{
						font-size: 15px;
						line-height: 60px;
					}
				}
			}
		}

		.ad{
			width: 260px;
			.el-image{
				width: 260px;
				height: 260px;
				margin-bottom: 15px;
			}
		}
	}





	.empty {
		margin-top: 45px;
	}

	.pager {
		text-align: center;
		margin-top: 30px;
	}

	.block-container {
		border:1px solid #eee;
		margin-bottom: 15px;
		.box {
			display: block;
			// overflow: hidden;
			display: flex;
			flex-wrap: wrap;

			.name {
				width: 60px;
				padding: 13px 10px;
			}

			.value {
				flex: 1;
				padding-bottom: 10px;

				.el-tag {
					margin: 10px 0 0 10px;
					border: 0;
					border-radius: 0;
					cursor: pointer;
				}

				.el-tag--plain {
					// background-color: ;
					color: #000;
				}
			}
		}

		.category {
			.row {
				display: flex;
				flex-wrap: wrap;
				border-bottom: 1px solid #eee;
				padding-bottom: 10px;
				margin-right: 10px;
				.cat1 {
					width: 100px;
				}
				.cat2{
					flex: 1;
				}
			}
		}
	}
</style>
